var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"bg-white button-dark py-3 xxl:py-4.1p border-spegra-dark-blue border hover-button dark-button text-spegra-dark-blue px-9 xxl:px-65.7p text-button-text"},[_c('span',[_vm._t("default")],2),_vm._v(" "),_c('icons-long-arrow',{staticClass:"ml-1 arrow inline-block"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }